/**
 * Google Maps Platform key (Maps JavaScript API + Geocoding API).
 * Restrict by HTTP referrer / API in Google Cloud Console.
 */
export const googleMapsApiKey = "AIzaSyDRiG83U1KD9Qkbydkyt-OjdOBOPIbByhc";
